import { useEffect, useState } from 'react';
import { v2 } from '@/api/v2Client';

export function SubmissionFollowButton({ submissionId }: { submissionId: string }) {
  const [subscribed, setSubscribed] = useState<boolean | null>(null);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [retry, setRetry] = useState(0);
  useEffect(() => {
    let stale = false;
    setSubscribed(null);
    setError(null);
    v2.submissions.getNotificationSubscription(submissionId)
      .then((value) => { if (!stale) setSubscribed(value.isSubscribed); })
      .catch(() => { if (!stale) setError('Notification preference could not be loaded.'); });
    return () => { stale = true; };
  }, [submissionId, retry]);

  async function toggle(): Promise<void> {
    if (subscribed === null) { setRetry((value) => value + 1); return; }
    setSaving(true);
    setError(null);
    try {
      const result = await v2.submissions.setNotificationSubscription(submissionId, !subscribed);
      setSubscribed(result.isSubscribed);
    } catch { setError('Notification preference could not be saved. Try again.'); }
    finally { setSaving(false); }
  }

  return <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
    <button type="button" className="btn btn-secondary" aria-pressed={subscribed ?? false}
      disabled={saving || (subscribed === null && error === null)} onClick={() => void toggle()}
      title="Receive one summary when classification or compilation finishes, including failures that need attention. Only for this submission."
    >{saving ? 'Saving…' : subscribed === null ? error ? 'Retry notifications' : 'Loading notifications…' : subscribed ? '🔔 Following submission' : '🔔 Follow submission'}</button>
    {error && <span role="alert" style={{ fontSize: 12, color: 'var(--danger, #b91c1c)' }}>{error}</span>}
  </div>;
}
